var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tags flex-wrap"},[_vm._l((_vm.tags),function(item,i){return [(i > 0 && _vm.$slots.marker)?_c('div',{staticClass:"marker"},[_vm._t("marker")],2):_vm._e(),_c('div',{staticClass:"item"},[_vm._v(_vm._s(item))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }